import { Component, Inject, OnInit,ElementRef } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { Subscription} from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AccountService } from '../../../services/account.service';
import { LookupService } from '../../../services/lookup.service';
import { UserAdminAccountComponent } from '../user-admin-account/user-admin-account.component';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faBan, faBookOpen, faBuilding, faEdit, faFileCsv, faFileDownload, faGlobe, faGlobeAfrica, faGlobeAmericas, faGlobeAsia, faGlobeEurope } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-user-admin-edit',
  templateUrl: './user-admin-edit.component.html',
  styleUrls: ['./user-admin-edit.component.scss']
})
export class UserAdminEditComponent implements OnInit {


  public formLayout = [];
  public dropDownItems = {};

  private accountsData$: Subscription;
  accountsData:any;

  private lookupData$: Subscription;
  lookupData = [];

  loading = false;
  useraccess = []; // load this directly without a service cause we don't need it anywhere else

  public selectedAccess = [];
  public allowSave = false;
  public fieldMessage = {};

  accessData = [];
  regionCount = 0;
  excludeActions = ['delete', 'ignore'];
  regionType = 'Region';
  regionSubValueAll = 'ALL';

  constructor(
    private http: HttpClient,
    public accountService: AccountService,
    public lookupService: LookupService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<UserAdminEditComponent>,    
    library: FaIconLibrary,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private el: ElementRef
      
  ) { 
    library.addIcons(faBuilding,faGlobe,faGlobeAfrica,faGlobeAmericas,faGlobeAsia,faGlobeEurope,faEdit,faBookOpen,faBan);
  }

  
  ngOnInit(): void {
    
    this.formLayout = [];

    // get the form layout - if there is nothing defined then put each field as a row
    
    if(this.data.tableDef.form==undefined){
      this.data.tableDef.fields.forEach(x => {
        this.formLayout.push([x.name]);      
      });
    } else {
      this.formLayout = this.data.tableDef.form
    }

    this.data.tableDef.fields.forEach(item => {
      if(item.type=="dropdown" && !(item.readonly && item.readonly === true)){
        this.dropDownItems[item.name] = this.getDropDownItems(item.values)
      } 
      
      this.fieldMessage[item.name] = "";
    });

    // if there is no data - then set the form defaults
    if(this.data.data["id"]==undefined){
      this.data.tableDef.fields.forEach(item => {
        if((item.default && item.default != "")){
          this.data.data[item.name] = item.default;
        }      
      });
    }

    // focus on the first editable field
    setTimeout(() => {
    const firstControl = this.el.nativeElement.querySelector('.editable');
    if (firstControl) {
      firstControl.focus();
    }
  },200);

    // wire up the accounts and load them
    this.accountsData$ = this.accountService.accounts$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){                  
          this.accountsData = responsedata;
        }
      }
    );
    this.accountService.loadAccounts();  

    // wire up the lookups (for the regions) and load them
    this.lookupData$ = this.lookupService.lookups$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){                  
          const { loading, data } = responsedata;
          if(!loading){
            const regions = JSON.parse(JSON.stringify(data || []));
            this.lookupData = regions.map(itm => {
              const { id, name, subregions } = itm;
              let subRegions = [];
              if (subregions) {
                subRegions = JSON.parse(subregions).map(sr => {
                  return {
                    ...sr,
                    type: 'salesOrgL2',
                    label: sr.name
                  }
                });
              }
              return {
                id,
                name,
                subregions: subRegions,
                label: name,
                type: 'region'
              };
            });
            this.getAccessTreeData();
          }
        }
      }
    );
    this.lookupService.loadLookups();      

    // get the user access - pass in the user id - or if new add the default line
    if(this.data.data["id"]!=undefined){
      this.getUserAccess(this.data.data["id"]);
    }
    

  }

  getItem(name){
    let x = this.data.tableDef.fields.filter(x => (x.name==name)) 
    return x[0];
  }

  isBlank(item){
    let fld = this.getItem(item)['name'];
    if(this.data.data[fld]==undefined || this.data.data[fld].trim()=="") return true;
    return false;
  }
  

  getColStyle(i,total){
    if(total==1) {
      return "";
    } else {
      if(i==0) {
        return "float:left;width: calc(" + Math.trunc(100/total) + "% - 15px)"
      } else {
        return "float:left;width: calc(" + Math.trunc(100/total) + "% - 15px); margin-left:30px"
      }
    }
    
  }


  getType(item){
    if(item["readonly"] && item["readonly"]===true){
      return "readonly";
    } else if(item["type"]=="dropdown") {
      return "dropdown"
    } else {
      return "string"
    }
  }

  // sort out the values option of the dropdown - allow simple array or array of objects with label and value properties - if
  // label is missing use the value
  getDropDownItems(vals){

    let rtn = [];
    if(Array.isArray(vals)){
      vals.forEach(x => {
        if(typeof x === 'object'){
          rtn.push({value:x["value"],label:x["label"]?x["label"]:x["value"]})
        } else {
          rtn.push({'value':x,'label':x})
        }
      });      
    }

    return rtn;

  }


  getUserAccess(userid){
    this.loading = true;

    let params = new HttpParams()
    .set('userid', userid.toString())

    this.http.get("/api/data/useraccess",{ params }).subscribe(
      (response: any) => {
        
        this.loading = false;
        this.useraccess = response;
        this.getAccessTreeData();
      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get data');
        console.log(error);
      }
    );
  }

  getUserAccessToShow(){
    return this.useraccess.filter(x => x["action"] == undefined || !this.excludeActions.includes(x["action"]))
                          .sort((x,y) => this.getSort(x) > this.getSort(y) ? 1 : -1)
  }

  getSort(x){
    let rtn = "";
    if(x.type=="Global") rtn = "a-" + x.valuelabel
    if(x.type=="Region") rtn = "b-"+ x.valuelabel
    if(x.type=="Account") rtn = "c-"+ x.valuelabel
    return rtn;
  }

  addUserAccess(accessType){
    const dialogRef = this.dialog.open(UserAdminAccountComponent, {
      height:'450px',
      width: '400px',
      data: {type:"account",data:this.accountsData.data, accessType:accessType}
    });

    dialogRef.afterClosed().subscribe(result => {
      
      if(result=="cancel") return;

      if (result && Array.isArray(result.selected)) {
        result.selected.forEach(id => {
          // check if we already have an entry
          let fnd = false;
          this.useraccess.forEach(x => {
            if(x.type=="Account" && x.value == id){
              x.access = result.accessType;
              x["action"] = "edit";
              fnd = true;
            }
          })
          if(!fnd){
            let newid = "Account-"+id;
            this.useraccess.push({id:newid,userid:this.data.data["id"],type:"Account",value:id,access:result.accessType,valuelabel:this.getAccountName(id),action:"add"})
          }

        });
        this.getAccessTreeData();
      }
    });

    this.onChange("");
  }

  addRegion(accessType){

    const dialogRef = this.dialog.open(UserAdminAccountComponent, {
      height:'450px',
      width: '400px',
      data: {type:"region",data:this.lookupData.filter(x => x.type=="region"), accessType:accessType}
    });

    dialogRef.afterClosed().subscribe(result => {
      
      if(result=="cancel") return;

      if (result && Array.isArray(result.selected)) {
        result.selected.forEach(id => {

          // For Region - we save the name rather than the id - so get the region details
          const { regionData, salesOrgL2Data } = this.getRegion(this.lookupData, id);
          if (regionData.id) {
            // check if we already have an entry
            let fnd = false;
            let addedItems = [];
            this.useraccess.filter(x => x.type === this.regionType && x.value == regionData.name).sort((l, r) => {
              return l.subvalue === this.regionSubValueAll ? -1 : 1;
            }).forEach(x => {
              if(salesOrgL2Data.id) {
                if (x.subvalue === this.regionSubValueAll) {
                  if (x.access === result.accessType) {
                    if (!this.excludeActions.includes(x.action)) {
                      fnd = true;
                    }
                  } else {
                    if (!this.excludeActions.includes(x.action)) {
                      x.action = 'delete';
                      regionData.subregions.forEach(sub => {
                        if (!result.selected.includes(sub.id)) {
                          const newItem = this.initRegionItem(x.access, regionData.name, sub.name);
                          addedItems.push(newItem);
                        }
                      });
                    }
                  }
                } else {
                  if (x.subvalue === salesOrgL2Data.name) {
                    if (fnd) {
                      x.action = 'delete';
                    } else {
                      if (x.action !== 'add') {
                        x.action = 'edit';
                      }
                      x.access = result.accessType;
                      fnd = true;
                    }
                  }
                }
              } else {
                if (x.subvalue === this.regionSubValueAll) {
                  if (x.action !== 'add') {
                    x.action = 'edit';
                  }
                  x.access = result.accessType;
                  fnd = true;
                } else {
                  x.action = 'delete';
                }
              }
            });
            if (!fnd) {
              const newItem = this.initRegionItem(result.accessType, regionData.name, salesOrgL2Data.id ? salesOrgL2Data.name : this.regionSubValueAll);
              addedItems.push(newItem);
            }
            this.useraccess = this.useraccess.concat(addedItems).filter(this.filterValidData);
          }
        });
        this.combineSalesOrgL2();
      }
    });

    this.onChange("");
  }

addGlobal(accessType){
  let fnd = false;
  this.useraccess.forEach(x => {
    if(x.type=="Global"){
      x.access = accessType;
      fnd = true;
    }
  })
  if(!fnd){
    let id = "Global-"+accessType;
    this.useraccess.push({id:id,userid:this.data.data["id"],type:"Global",value:"Global",access:accessType,valuelabel:"Global",action:"add"})
  }
  this.getAccessTreeData();

  this.onChange("");
}

  compareFunction(o1,o2){
    return o1.id===o2.id;
  }

  initRegionItem(accessType: string, value: string, subvalue: string) {
    return {
      id: `${this.regionType}-${++this.regionCount}`,
      userid: this.data.data.id,
      type: this.regionType,
      value,
      access: accessType,
      valuelabel: value,
      subvalue,
      action: 'add'
    };
  }

  getSelectedOptions() {
    const selectedOptions = {
      regionSelectedOptions: [],
      otherSelectedOptions: [],
      regionAccessData: []
    };
    this.getUserAccessTreeToShow().forEach(itm => {
      if (itm.type === this.regionType) {
        selectedOptions.regionAccessData.push({
          ...itm
        });
        if (this.selectedAccess.includes(itm.id)) {
          selectedOptions.regionSelectedOptions.push(itm.id);
        } else {
          itm.subregions.forEach(sub => {
            if (this.selectedAccess.includes(sub.id)) {
              selectedOptions.regionSelectedOptions.push(sub.id);
            }
          });
        }
      } else {
        if (this.selectedAccess.includes(itm.id)) {
          selectedOptions.otherSelectedOptions.push(itm.id);
        }
      }
    });
    return selectedOptions;
  }

  deleteItem(removeItems: any[], item: any) {
    if(item.action === 'add'){
      removeItems.push(item.id);
    } else {
      item.action = 'delete';
    }
  }

  updateAccessType(item: any, accessType: string) {
    if (accessType !== 'N' || item.type !== 'Global'){
      // Global doens't have no access
      if (item.access !== accessType){
        item.access = accessType;
        if (item.action !== 'add') {
          item.action = "edit";
        }
      }
    }
  }

  filterValidData = itm => (!this.excludeActions.includes(itm.action) || typeof itm.id !== 'string');

  combineSalesOrgL2() {
    this.getUserAccessTreeToShow().forEach(item => {
      if (item.type === this.regionType) {
        const regionData = this.lookupData.find(d => d.name === item.value);
        if (regionData) {
          const data = this.useraccess.filter(a => a.type === this.regionType && a.value === regionData.name && !this.excludeActions.includes(a.action));
          let allSelected = true;
          let accessTypes = [];
          let distinctSalesOrgL2 = {};

          data.forEach(a => {
            if (distinctSalesOrgL2[a.subvalue]) {
              if (distinctSalesOrgL2[a.subvalue].includes(a.access)) {
                a.action = 'delete';
              } else {
                distinctSalesOrgL2[a.subvalue].push(a.access);
              }
            } else {
              distinctSalesOrgL2[a.subvalue] = [a.access];
            }
          });

          regionData.subregions.forEach(sub => {
            const subItem = data.find(a => a.subvalue === sub.name);
            if (subItem) {
              if (!accessTypes.includes(subItem.access)) {
                accessTypes.push(subItem.access);
              }
            } else {
              allSelected = false;
            }
          });

          let addedItems = [];
          if (allSelected && accessTypes.length === 1) {
            const accessType = accessTypes[0];
            let fnd = false;
            this.useraccess.filter(a => a.type === this.regionType && a.value === regionData.name).forEach(a => {
              if (a.subvalue === this.regionSubValueAll) {
                if (a.action !== 'add') {
                  a.action = 'edit';
                }
                a.access = accessType;
                fnd = true;
              } else {
                a.action = 'delete';
              }
            });
            if (!fnd) {
              const newItem = this.initRegionItem(accessType, regionData.name, this.regionSubValueAll);
              addedItems.push(newItem);
            }
          }
          this.useraccess = this.useraccess.concat(addedItems).filter(this.filterValidData);
        }
      }
    });
    this.getAccessTreeData();
    setTimeout(() => {
      this.selectedAccess = [];
    }, 0);
  }

  remove(){
    const { regionSelectedOptions, otherSelectedOptions, regionAccessData } = this.getSelectedOptions();
    let removeItems = [];
    let addedItems = [];
    regionSelectedOptions.forEach(x => {
      const { regionData, salesOrgL2Data } = this.getRegion(regionAccessData, x);
      if (regionData.id) {
        this.useraccess.filter(a => a.value === regionData.value && !this.excludeActions.includes(a.action)).forEach(a => {
          if (salesOrgL2Data.id) {
            if (a.subvalue === this.regionSubValueAll) {
              this.deleteItem(removeItems, a);
              regionData.subregions.forEach(sub => {
                if (!regionSelectedOptions.includes(sub.id)) {
                  const newItem = this.initRegionItem(a.access, regionData.value, sub.subvalue);
                  addedItems.push(newItem);
                }
              });
            } else {
              if (a.subvalue === salesOrgL2Data.subvalue) {
                this.deleteItem(removeItems, a);
              }
            }
          } else {
            this.deleteItem(removeItems, a);
          }
        });
      }
    });
    otherSelectedOptions.forEach(x => {
      const item = this.useraccess.find(y => x === y.id);
      if (item) {
        this.deleteItem(removeItems, item);
      }
    });
    this.useraccess = this.useraccess.concat(addedItems).filter(ua => !removeItems.includes(ua.id)).filter(this.filterValidData);
    this.combineSalesOrgL2();

    this.onChange("");

  }

  change(accessType){
    const { regionSelectedOptions, otherSelectedOptions, regionAccessData } = this.getSelectedOptions();
    let removeItems = [];
    let addedItems = [];
    regionSelectedOptions.forEach(x => {
      const { regionData, salesOrgL2Data } = this.getRegion(regionAccessData, x);
      if (regionData.id) {
        this.useraccess.filter(a => a.value === regionData.value && !this.excludeActions.includes(a.action)).forEach(a => {
          if (salesOrgL2Data.id) {
            if (a.subvalue === this.regionSubValueAll) {
              if (a.access !== accessType) {
                if(a.action === 'add'){
                  removeItems.push(a.id);
                }
                a.action = 'delete';
                regionData.subregions.forEach(sub => {
                  const newItem = this.initRegionItem(regionSelectedOptions.includes(sub.id) ? accessType : a.access, regionData.value, sub.subvalue);
                  addedItems.push(newItem);
                });
              }
            } else {
              if (a.subvalue === salesOrgL2Data.subvalue) {
                this.updateAccessType(a, accessType);
              }
            }
          } else {
            if (a.subvalue === this.regionSubValueAll) {
              this.updateAccessType(a, accessType);
            } else {
              const regionItem = this.lookupData.find(itm => itm.name === regionData.value);
              let allSelected = true;
              if (regionItem) {
                regionItem.subregions.forEach(itm => {
                  const subItem = regionData.subregions.find(sub => sub.subvalue === itm.name);
                  if (!subItem) {
                    allSelected = false;
                  }
                });
              }
              if (allSelected) {
                this.deleteItem(removeItems, a);
                const newItem = this.initRegionItem(accessType, regionData.value, this.regionSubValueAll);
                addedItems.push(newItem);
              } else {
                this.updateAccessType(a, accessType);
              }
            }
          }
        });
      }
    });
    otherSelectedOptions.forEach(x => {
      const item = this.useraccess.find(y => x === y.id);
      if (item) {
        this.updateAccessType(item, accessType);
      }
    });
    this.useraccess = this.useraccess.concat(addedItems).filter(ua => !removeItems.includes(ua.id)).filter(this.filterValidData);
    this.combineSalesOrgL2();

    this.onChange("");

  }


  getAccountName(id){    
    let acnt = this.accountsData.data.filter(x => (x.id == id))
    return (acnt.length>0 ? acnt[0].name : "")
  }

  getRegion(lookupData: any[], id: any){
    const result = {
      regionData: {} as any,
      salesOrgL2Data: {} as any
    };
    const region = lookupData.find(x => x.id === id);
    if (region) {
      result.regionData = region;
    } else {
      for (const item of lookupData) {
        const sub = item.subregions.find(s => s.id === id);
        if (sub) {
          result.regionData = item;
          result.salesOrgL2Data = sub;
          break;
        }
      }
    }
    return result;
  }

  getRegionIcon(region){
    if(region=="AMS") return "globe-americas"
    if(region=="ASIA") return "globe-asia"
    if(region=="ANZ") return "globe-asia"
    if(region=="SE") return "globe-africa"
    return "globe-europe"
  }

  getAccessTreeData() {
    let accessData = this.useraccess.filter(item => item.type !== this.regionType);
    const regions = this.useraccess.filter(item => (item.type === this.regionType && (!item.action || !this.excludeActions.includes(item.action))));
    if (regions.length) {
      this.lookupData.forEach(item => {
        const regionItems = regions.filter(itm => itm.value === item.name).sort((l, r) => l.access > r.access ? -1 : 1);
        if (regionItems.length) {
          const regionItem = regionItems[0];
          let regionData = {
            ...regionItem,
            id: regionItem.subvalue === this.regionSubValueAll ? regionItem.id : regionItem.value,
            oriId: regionItem.id,
            subvalue: this.regionSubValueAll,
            subregions: []
          };

          item.subregions.forEach(sub => {
            const subItem = regionItems.find(itm => itm.subvalue === sub.name);
            if (subItem) {
              regionData.subregions.push({
                ...subItem
              });
            } else {
              if (regionItem.subvalue === this.regionSubValueAll) {
                regionData.subregions.push({
                  ...regionItem,
                  id: sub.name,
                  subvalue: sub.name
                });
              }
            }
          });

          const additionalSubs = regionItems.filter(itm => itm.subvalue !== this.regionSubValueAll && !regionData.subregions.find(sub => sub.subvalue === itm.subvalue));
          regionData.subregions = regionData.subregions.concat(additionalSubs);
          accessData.push(regionData);
        }
      });

      const additionalRegions = regions.filter(itm => !accessData.find(a => a.value === itm.value));
      let distinctRegions = [];
      additionalRegions.forEach(itm => {
        if (!distinctRegions.includes(itm.value)) {
          distinctRegions.push(itm.value);
        };
      });
      distinctRegions.forEach(itm => {
        const subs = additionalRegions.filter(sub => sub.value === itm).sort((l, r) => l.access > r.access ? -1 : 1);
        const subItem = subs[0];
        const regionData = {
          ...subItem,
          id: subItem.subvalue === this.regionSubValueAll ? subItem.id : subItem.value,
          oriId: subItem.id,
          subvalue: this.regionSubValueAll,
          subregions: additionalRegions.filter(sub => sub.subvalue !== this.regionSubValueAll)
        };
        accessData.push(regionData);
      });
    }
    this.accessData = accessData;
  }

  getUserAccessTreeToShow(){
    return this.accessData.filter(x => x["action"] == undefined || !this.excludeActions.includes(x["action"]))
                          .sort((x,y) => this.getSort(x) > this.getSort(y) ? 1 : -1)
  }

  handleChange(event: any) {
    const { option: { value, selected } } = event;
    let regionData = null;
    let currentOptionData = null;
    const regions = this.accessData.filter(itm => itm.type === this.regionType);
    for (const item of regions) {
      if (item.id === value) {
        regionData = item;
        currentOptionData = item;
        break;
      } else {
        for (const sub of item.subregions) {
          if (sub.id === value) {
            regionData = item;
            currentOptionData = sub;
            break;
          }
        }
      }
    }

    if (currentOptionData && regionData) {
      const { subregions } = regionData;
      if (currentOptionData.subregions) {
        if (selected) {
          let arr = [];
          subregions.forEach(itm => {
            if (!this.selectedAccess.includes(itm.id)) {
              arr.push(itm.id);
            }
          });
          this.selectedAccess = this.selectedAccess.concat(arr);
        } else {
          this.selectedAccess = this.selectedAccess.filter(itm => {
            const isSubItem = subregions.find(sub => sub.id === itm);
            return isSubItem ? false : true;
          });
        }
      } else {
        const allSelected = subregions.every(itm => this.selectedAccess.includes(itm.id));
        if (allSelected) {
          this.selectedAccess = this.selectedAccess.concat([regionData.id]);
        } else {
          this.selectedAccess = this.selectedAccess.filter(itm => itm !== regionData.id);
        }
      }
    }
  }

  onChange(event){

    // Check if the form is valid
    let valid = true;
    let validmessage = "";
    let re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    this.data.tableDef.fields.forEach(x => {      
      
      this.fieldMessage[x["name"]] = "";

      if(x["required"]===true && (this.data.data[x["name"]]==undefined || this.data.data[x["name"]].trim()=="")){
        valid = false;        
        this.fieldMessage[x["name"]] = "Field is required"
      }

      else if(x["unique"]===true){

        let id = this.data.data["id"] ? this.data.data["id"] : "";
        let val = this.data.data[x["name"]] ? this.data.data[x["name"]] : "";
        if(!re.test(val)){
          valid = false;
          this.fieldMessage[x["name"]] = "User name should be an email"
          return false;
        }; 
        if(this.data.allData.filter(r => (r[x["name"]].toLowerCase().trim() == val.toLowerCase().trim() && r["id"] != id )).length > 0 ){
          valid = false;
          this.fieldMessage[x["name"]] = "There is already a user with this username"
        }
      }

    });

    if(valid){
      this.allowSave = true;
    } else {
      this.allowSave = false;
    }

  }

  save():void {
    if(!this.allowSave) return;
    // add in the useraccess data, only include things that have changed
    let rtn = {user:{...this.data.data},
               useraccess:this.useraccess.filter(x => (x.action && (x.action == "add" || x.action == "edit" || x.action == "delete")))}
    this.dialogRef.close(rtn);
  }

  close(){
    this.dialogRef.close("cancel");
  }

  delete(){
    const dialogRef = this.dialog.open(OKCancelDialog, {
      width: '350px',
      data: {title:"Confirm", text: "Are you sure you want to delete this record?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result=="ok"){
        this.dialogRef.close("delete");
      }      
    });
  }

}



// TODO - put this as a seperate component - bound to need it
@Component({
  selector: 'okcanceldialog',
  styleUrls: ['./user-admin-edit.component.scss'],
  template: `<h3 class="mat-dialog-title aip-dialog-title">{{data.title}}</h3>
  <div class="mat-dialog-content aip-dialog-text">
    {{data.text}}
</div>
  <div class="mat-dialog-actions" align="end">
    <button class="mat-focus-indicator aip-button mat-raised-button mat-button-base mat-primary" (click)="ok()">OK</button>
    <button class="mat-focus-indicator aip-button-alt mat-raised-button mat-button-base" (click)="cancel()" cdkFocusInitial>Cancel</button>
</div>
    `
})
export class OKCancelDialog {

  constructor(
    public dialogRef: MatDialogRef<OKCancelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ok(): void {
      this.dialogRef.close("ok");
    }

  cancel(): void {
    this.dialogRef.close("cancel");
  }

}

